import { identity, isEmpty } from 'ramda';
import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { getHtmlElUID } from '../../../utils/helpers';
import './ModalContainer.scss';

export const ModalContainer = (props) => {
  const {
    isOpen,
    size = 'medium',
    onSubmit = () => {},
    onCancel = () => {},
    onToggle = () => {},
    onOpened = () => {},
    onClosed = () => {},
    showCloseIcon = false,
    className,
    title,
    text,
    btnSubmitText = 'Submit',
    btnCancelText = 'Cancel',
    buttons = [],
    toggle = null,
    asToggleButtonFn = () => null,
    preventEscape = false,
    ariaRole = 'dialog',
  } = props;

  const [opened, setOpened] = useState(isOpen);

  const proxyToggle = () => {
    toggle ? toggle(opened, setOpened) : setOpened(!opened);
    onToggle(opened);
  };

  const proxyOnSubmit = async () => {
    await onSubmit();
    setOpened(false);
  };

  const proxyOnCancel = async () => {
    await onCancel();
    setOpened(false);
  };

  const getButtons = () => {
    const result =
      buttons === false
        ? []
        : isEmpty(buttons)
        ? [
            <button className="modal-button" key="btn-modal-submit" onClick={proxyOnSubmit}>
              {btnSubmitText}
            </button>,
            <button className="modal-button" key="btn-modal-cancel" onClick={proxyOnCancel}>
              {btnCancelText}
            </button>,
          ]
        : buttons.map((btn, idx) => (
            <button
              className="modal-button"
              key={`btn-modal-${idx}`}
              onClick={() => (btn.onClick ? btn.onClick({ setOpened }) : void 0)}
              disabled={btn.disabled}>
              {btn.label || 'no label'}
            </button>
          ));
    return result;
  };

  const classNames = ['app-modal', `app-modal-size-${size}`, className ? `app-modal-${className}` : null].filter(identity).join(' ');

  const msgElId = getHtmlElUID();

  useEffect(() => {
    setOpened(isOpen);
  }, [isOpen]);

  return (
    <React.Fragment>
      {asToggleButtonFn(opened, setOpened)}
      <Modal
        isOpen={opened}
        className={classNames}
        toggle={proxyToggle}
        labelledBy={msgElId}
        onOpened={onOpened}
        onClosed={onClosed}
        keyboard={!preventEscape}
        role={ariaRole}>
        <ModalHeader tag="div" className="ScalaSansOT-Bold bold-font">
          {title}
          {showCloseIcon ? (
            <i
              tabIndex="0"
              aria-label="close dialog."
              role="button"
              className="far fa-times btn-modal-cross-right"
              onKeyDown={({ key }) => {
                if (key === 'Enter') {
                  proxyToggle();
                }
              }}
              onClick={proxyToggle}
            />
          ) : (
            void 0
          )}
        </ModalHeader>
        <ModalBody>{text}</ModalBody>
        <ModalFooter>{getButtons()}</ModalFooter>
        <div id={msgElId} style={{ display: 'none' }}>
          {props['aria-label'] || title}
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default ModalContainer;
